import React, { useEffect, useState } from "react";

/**
 * Click-to-expand image. Renders the image inline at its container size;
 * tap → full-screen modal with Esc / click-outside / × to close.
 */
export default function ImageLightbox({ src, alt = "", className }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("keydown", onKey);
    // Lock background scroll while the lightbox is up.
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open]);

  return (
    <>
      <img
        src={src}
        alt={alt}
        className={className}
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        loading="lazy"
      />
      {open && (
        <div className="pm-lightbox" onClick={() => setOpen(false)}>
          <button
            type="button"
            className="pm-lightbox__close"
            onClick={() => setOpen(false)}
            aria-label="Close"
          >
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><path d="M4 4 L14 14 M14 4 L4 14"/></svg>
          </button>
          <img
            src={src}
            alt={alt}
            className="pm-lightbox__img"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  );
}
